import { render, staticRenderFns } from "./TerminalTable.vue?vue&type=template&id=f4bec9d8&scoped=true&"
import script from "./TerminalTable.vue?vue&type=script&lang=js&"
export * from "./TerminalTable.vue?vue&type=script&lang=js&"
import style0 from "./TerminalTable.vue?vue&type=style&index=0&id=f4bec9d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bec9d8",
  null
  
)

export default component.exports